import { ACTION } from "src/util/utils";
import { KEYS, MODULE_KEY } from "./actions";


export const REDUCER_KEY = KEYS[MODULE_KEY + ACTION.STATE_KEY];

export interface IFedexState {
  loading: boolean;
  error: any;
  data: [];
}

const defaultState: IFedexState = {
  loading: false,
  error: null,
  data: [],
};

export const expressOfficeReducer = (
  state = defaultState,
  { type, payload }: any
) => {
  switch (type) {
    case KEYS[MODULE_KEY + ACTION.FETCH]:
      return {
        ...state,
        loading: true,
      };

    case KEYS[MODULE_KEY + ACTION.SUCCESS]:
      return {
        ...state,
        loading: false,
        data: [...payload],
      };
    case KEYS[MODULE_KEY + ACTION.FAILED]:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    default:
      return state;
  }
};
